import { Types as AuthActions } from './auth/types';
import { Types as GlobalActions } from './global/types';

const AllActions = {
    auth: AuthActions,
    global: GlobalActions
}

export default AllActions;